import React from 'react';

const Header = () => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().toLocaleString('en-US', { 'month': 'long' });

    return(
        <div className="header columns">
            <div className="column">
                <h1 id="title">
                    Random Geometry-Algebra Word Problem Generator
                </h1>
                <h2>
                    Practice understanding perimeter, area, surface area, volume, and more! Educational math tool updated {currentMonth} {currentYear}, &copy; {currentYear} <a href="http://pioslabs.com/">Pios Labs</a>.
                </h2>
                <h3>
                    
                </h3>            
            </div>
        </div>
    );

};

export default Header;